var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaFabula1Bloq({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 260,
    viewBox: "0 0 213 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.182 112.44C170.182 149.683 142.321 168.305 109.206 179.106C107.472 179.656 105.589 179.629 103.873 179.031C70.6786 168.305 42.8175 149.683 42.8175 112.44V60.2984C42.8175 58.3228 43.6562 56.4282 45.149 55.0313C46.6419 53.6344 48.6666 52.8496 50.7778 52.8496C66.6984 52.8496 86.5992 43.9111 100.45 32.589C102.137 31.2408 104.282 30.5 106.5 30.5C108.718 30.5 110.863 31.2408 112.55 32.589C126.48 43.9856 146.302 52.8496 162.222 52.8496C164.333 52.8496 166.358 53.6344 167.851 55.0313C169.344 56.4282 170.182 58.3228 170.182 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_31152)",
    stroke: "url(#paint1_linear_2162_31152)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.91 74.2329L138.006 101.671L134.248 109.189L115.016 115.783L96.9546 109.214L92.5845 95.0132L95.3198 74.2241L104.204 72.6567L111.861 78.6733L112.13 78.8843L112.441 78.7417L125.753 72.6392L136.91 74.2329Z",
    fill: "#C0C0C0",
    stroke: "#C0C0C0",
    strokeWidth: 1.12195
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 107.402C104.069 106.721 103.793 102.354 115.573 102.354C127.354 102.354 125.819 106.882 133.524 107.402L123.988 114.134L117.256 116.378L109.402 115.256L103.232 113.012L96.5 107.402Z",
    fill: "#C0C0C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.377 80.9746L102.55 82.1476M129.528 80.9746L128.355 82.1476M110.761 92.7041V91.5312M120.144 92.7041V91.5312M120.144 102.088H110.761M115.453 102.088V106.78M136.096 74.4061C132.343 70.6527 126.478 70.6527 122.725 74.4061L120.379 76.752C117.114 76.2418 113.791 76.2418 110.526 76.752L108.18 74.4061C106.454 72.6018 104.081 71.5573 101.585 71.5023C99.0878 71.4473 96.6716 72.3863 94.8673 74.1129C93.063 75.8394 92.0185 78.212 91.9635 80.7086C91.9085 83.2053 92.8475 85.6215 94.5741 87.4258C92.8962 90.0538 92.0011 93.1051 91.9936 96.223C91.9936 107.249 102.55 116.163 115.453 116.163C128.355 116.163 138.912 107.249 138.912 96.223C138.926 93.0652 138.03 89.9701 136.331 87.3085C139.85 83.5551 139.85 77.925 136.096 74.4061Z",
    stroke: "#C0C0C0",
    strokeWidth: 4.6918,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8906 103.475L101.013 110.373L101.088 110.616L101.321 110.72L106.08 112.834L106.602 117.008L106.618 117.14L106.691 117.25L109.913 122.083L107.748 129.664L104.507 139.387L81.2656 139.927L80.2236 133.676L80.1807 133.414L79.9492 133.281L76.2432 131.164L74.1084 120.489L77.2627 117.335L77.334 117.264L77.377 117.171L80.1484 111.072L86.6611 103.475H98.8906Z",
    fill: "#C0C0C0",
    stroke: "#C0C0C0",
    strokeWidth: 1.12195
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 79.6707,
    y: 134.329,
    width: 25.8049,
    height: 4.4878,
    fill: "#C0C0C0",
    stroke: "#C0C0C0",
    strokeWidth: 1.12195
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4268,
    y: 126.476,
    width: 30.2927,
    height: 4.4878,
    fill: "#C0C0C0",
    stroke: "#C0C0C0",
    strokeWidth: 1.12195
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 78.5488,
    y: 111.89,
    width: 28.0488,
    height: 4.4878,
    fill: "#C0C0C0",
    stroke: "#C0C0C0",
    strokeWidth: 1.12195
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.1585,
    y: 104.037,
    width: 16.8293,
    height: 4.4878,
    fill: "#C0C0C0",
    stroke: "#C0C0C0",
    strokeWidth: 1.12195
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7526,
    y: 130.89,
    width: 11.1427,
    height: 4.4878,
    transform: "rotate(-89.6421 89.7526 130.89)",
    fill: "#C0C0C0",
    stroke: "#C0C0C0",
    strokeWidth: 1.12195
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8974 102.966H86.637C84.5641 102.966 82.8836 104.646 82.8836 106.719C82.8836 108.792 84.5641 110.473 86.637 110.473H97.8974C99.9703 110.473 101.651 108.792 101.651 106.719C101.651 104.646 99.9703 102.966 97.8974 102.966Z",
    stroke: "#C0C0C0",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.527 110.473H81.0068C78.9338 110.473 77.2534 112.154 77.2534 114.227C77.2534 116.3 78.9338 117.98 81.0068 117.98H103.527C105.6 117.98 107.281 116.3 107.281 114.227C107.281 112.154 105.6 110.473 103.527 110.473Z",
    stroke: "#C0C0C0",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0206 125.486H107.281C108.276 125.486 109.231 125.091 109.935 124.387C110.639 123.683 111.034 122.728 111.034 121.733C111.034 120.737 110.639 119.783 109.935 119.079C109.231 118.375 108.276 117.979 107.281 117.979H77.2534C76.258 117.979 75.3033 118.375 74.5994 119.079C73.8955 119.783 73.5 120.737 73.5 121.733C73.5 122.728 73.8955 123.683 74.5994 124.387C75.3033 125.091 76.258 125.486 77.2534 125.486H88.5137",
    stroke: "#C0C0C0",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0207 121.733C96.0207 119.66 94.3403 117.979 92.2673 117.979C90.1943 117.979 88.5139 119.66 88.5139 121.733V129.24C88.5139 131.313 90.1943 132.993 92.2673 132.993C94.3403 132.993 96.0207 131.313 96.0207 129.24V121.733Z",
    stroke: "#C0C0C0",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M105.404 125.486C106.4 125.486 107.354 125.882 108.058 126.586C108.762 127.29 109.158 128.244 109.158 129.24C109.158 130.235 108.762 131.19 108.058 131.894C107.354 132.598 106.4 132.993 105.404 132.993H79.1301C78.1347 132.993 77.18 132.598 76.4761 131.894C75.7722 131.19 75.3767 130.235 75.3767 129.24C75.3767 128.244 75.7722 127.29 76.4761 126.586C77.18 125.882 78.1347 125.486 79.1301 125.486",
    stroke: "#C0C0C0",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M101.651 132.993H82.8837C80.8107 132.993 79.1302 134.673 79.1302 136.746C79.1302 138.819 80.8107 140.5 82.8837 140.5H101.651C103.724 140.5 105.404 138.819 105.404 136.746C105.404 134.673 103.724 132.993 101.651 132.993Z",
    stroke: "#C0C0C0",
    strokeWidth: 3.75344,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5327 202.136V222.5H78.7088L68.358 207.565H68.169V222.5H65.0966V202.136H67.9403L78.3011 217.091H78.4901V202.136H81.5327ZM85.7759 222.5V207.227H88.7489V222.5H85.7759ZM86.0543 205.189L88.381 200.605H91.5131L88.4308 205.189H86.0543ZM105.814 207.227L100.276 222.5H97.0938L91.5455 207.227H94.7372L98.6051 218.98H98.7642L102.622 207.227H105.814ZM114.671 222.808C113.166 222.808 111.87 222.487 110.783 221.844C109.703 221.194 108.867 220.283 108.277 219.109C107.694 217.929 107.402 216.547 107.402 214.963C107.402 213.399 107.694 212.02 108.277 210.827C108.867 209.634 109.689 208.702 110.743 208.033C111.804 207.363 113.043 207.028 114.462 207.028C115.324 207.028 116.159 207.171 116.968 207.456C117.776 207.741 118.502 208.188 119.145 208.798C119.788 209.408 120.295 210.2 120.667 211.175C121.038 212.143 121.223 213.319 121.223 214.705V215.759H109.083V213.531H118.31C118.31 212.749 118.151 212.056 117.833 211.453C117.515 210.843 117.067 210.363 116.49 210.011C115.92 209.66 115.251 209.484 114.482 209.484C113.647 209.484 112.917 209.69 112.294 210.101C111.678 210.505 111.201 211.036 110.863 211.692C110.531 212.341 110.365 213.047 110.365 213.81V215.55C110.365 216.571 110.544 217.439 110.902 218.155C111.267 218.871 111.774 219.418 112.424 219.795C113.073 220.167 113.832 220.352 114.701 220.352C115.264 220.352 115.778 220.273 116.242 220.114C116.706 219.948 117.107 219.703 117.445 219.378C117.783 219.053 118.042 218.652 118.221 218.175L121.034 218.682C120.809 219.51 120.405 220.236 119.821 220.859C119.245 221.476 118.519 221.956 117.644 222.301C116.775 222.639 115.784 222.808 114.671 222.808ZM127.495 202.136V222.5H124.522V202.136H127.495ZM146.591 202.136V222.5H143.509V205.219H143.389L138.517 208.401V205.457L143.598 202.136H146.591Z",
    fill: "#C0C0C0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5 127.61V123.5C93.5 119.92 94.9223 116.486 97.4541 113.954C99.9858 111.422 103.42 110 107 110C110.58 110 114.014 111.422 116.546 113.954C119.078 116.486 120.5 119.92 120.5 123.5V127.61C122.73 127.776 124.18 128.196 125.242 129.258C127 131.014 127 133.844 127 139.5C127 145.156 127 147.986 125.242 149.742C123.486 151.5 120.656 151.5 115 151.5H99C93.344 151.5 90.514 151.5 88.758 149.742C87 147.986 87 145.156 87 139.5C87 133.844 87 131.014 88.758 129.258C89.818 128.196 91.27 127.776 93.5 127.61ZM96.5 123.5C96.5 120.715 97.6062 118.045 99.5754 116.075C101.545 114.106 104.215 113 107 113C109.785 113 112.455 114.106 114.425 116.075C116.394 118.045 117.5 120.715 117.5 123.5V127.508C116.735 127.501 115.901 127.499 115 127.5H99C98.0973 127.499 97.264 127.501 96.5 127.508V123.5ZM107 134C107.398 134 107.779 134.158 108.061 134.439C108.342 134.721 108.5 135.102 108.5 135.5V143.5C108.5 143.898 108.342 144.279 108.061 144.561C107.779 144.842 107.398 145 107 145C106.602 145 106.221 144.842 105.939 144.561C105.658 144.279 105.5 143.898 105.5 143.5V135.5C105.5 135.102 105.658 134.721 105.939 134.439C106.221 134.158 106.602 134 107 134Z",
    fill: "#8E58BF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_31152",
    x1: 106.5,
    y1: 30.5,
    x2: 106.5,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497066,
    stopColor: "#ECE6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECE6F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_31152",
    x1: 106.5,
    y1: 30.5,
    x2: 106.5,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaFabula1Bloq);
export default __webpack_public_path__ + "static/media/Medalha_fabula_1_bloq.ee7248417801e8f65c86a61d75dea36e.svg";
export { ForwardRef as ReactComponent };